import { debounce } from "./utils";


function fixedHeader(mqList, mqMinWidth) {
  const header = document.querySelector('.ne-header');
  const headerWrapper = document.querySelector('.ne-header__wrapper');
  const nav = document.querySelector('.ne-nav');
  const subscribeButtons = document.querySelectorAll('.ne-header__menu-subscribe');

  let scrollPos = 0;

  let { headerHeight, navHeight } = calculateHeights();

  const body = document.body;

  // Recalculate heights when logging in & out as the masthead gets hidden
  const mutationObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'data-has-access'
      ) {
        const waitForVisibleHeader = setInterval(() => {
          const newHeaderHeight = header.offsetHeight;
          const newNavHeight = nav.offsetHeight;

          if (newHeaderHeight > 0 && newNavHeight > 0) {
            clearInterval(waitForVisibleHeader);
            headerHeight = newHeaderHeight;
            navHeight = newNavHeight;
            onScrollHeader(window.scrollY);
          }
        }, 100);
      }
    }
  });

  mutationObserver.observe(body, {
    attributes: true,
    attributeFilter: ['data-has-access']
  });

  function calculateHeights() {
    return {
      headerHeight: header.offsetHeight,
      navHeight: nav.offsetHeight
    };
  }

  function onScrollHeader(scrollPos) {
    const transformValue = (headerHeight - navHeight);

    header.style.minHeight = `${headerHeight}px`;

    if (scrollPos > headerHeight) {
      headerPreAnimated(transformValue);
    }

    if (scrollPos > headerHeight + 25) {
      headerAnimated(navHeight);
    }

    if (scrollPos < headerHeight) {
      headerDefault();
    }
  }

  function headerPreAnimated(transformValue) {
    headerWrapper.classList.add('ne-header__wrapper--pre-animated');
    headerWrapper.style.transform = `translateY(-${transformValue}px)`;
    nav.classList.add('ne-nav--pre-animated');
    nav.style.maxHeight = 0;
  }

  function headerAnimated(navHeight) {
    headerWrapper.classList.remove('ne-header__wrapper--pre-animated');
    headerWrapper.classList.add('ne-header__wrapper--animated');
    nav.style.maxHeight = `${navHeight}px`;
    nav.classList.remove('ne-nav--pre-animated');
    nav.classList.add('ne-nav--animated');
    subscribeButtons.forEach(btn => {
      btn.classList.add('ne-header__menu-subscribe--animated');
    });
  }

  function headerDefault() {
    headerWrapper.classList.remove('ne-header__wrapper--pre-animated', 'ne-header__wrapper--animated');
    headerWrapper.removeAttribute('style');
    nav.classList.remove('ne-nav--pre-animated', 'ne-nav--animated');
    nav.removeAttribute('style');
    subscribeButtons.forEach(btn => {
      btn.classList.remove('ne-header__menu-subscribe--animated');
      btn.firstChild?.removeAttribute('style');
    });
  }

  function stripAttributes() {
    header.removeAttribute('style');
    headerWrapper.classList.remove('ne-header__wrapper--pre-animated', 'ne-header__wrapper--animated');
    headerWrapper.removeAttribute('style');
    nav.classList.remove('ne-nav--pre-animated', 'ne-nav--animated');
    nav.removeAttribute('style');
    subscribeButtons.forEach(btn => {
      btn.removeAttribute('style');
      btn.classList.remove('ne-header__menu-subscribe--animated');
    });
  }

  const scrollDebounce = debounce(() => {
    const screenWidth = document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;

    if (screenWidth >= mqMinWidth) {
      scrollPos = window.scrollY;
      window.requestAnimationFrame(onScrollHeader.bind(null, scrollPos));
    }
  });

  window.addEventListener('scroll', scrollDebounce, { passive: true });

  mqList.addEventListener('change', function (e) {
    if (!e.matches) {
      stripAttributes();
    } else {
      const scrollPos = window.scrollY;
      onScrollHeader(scrollPos);
    }
  });
}

// Only run layout-dependent code when full page is loaded
window.addEventListener('load', function () {
  const screenWidth = document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;
  const mqMinWidth = 1180;
  const mqList = window.matchMedia(`(min-width: ${mqMinWidth}px)`);

  if (screenWidth >= mqMinWidth) {
    fixedHeader(mqList, mqMinWidth);
  }

  mqList.addEventListener('change', (e) => {
    if (!e.matches) return;
    fixedHeader(mqList, mqMinWidth);
  });
});
